import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import localeExtraTh from '@angular/common/locales/extra/th';
import localeTh from '@angular/common/locales/th';
import { TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { environment as env } from '../../environments/environment';
import { Observable } from 'rxjs';

registerLocaleData(localeTh, 'th', localeExtraTh);



// configure a custom TranslateLoader
// export function HttpLoaderFactory(http: HttpClient) {

//   return new TranslateHttpLoader(http, env.apiEndpoint + '/translate/', '');
// }


export class WebpackTranslateLoader implements TranslateLoader {

  private headers = new HttpHeaders({
    'Expires': '-1',
    'Pragma': 'no-cache',
    'Cache-Control': 'no-cache, no-store, must-revalidate'
  });
  constructor(private http: HttpClient) {}
  getTranslation(lang: string): Observable<any> {
    return   this.http.get(  env.translateUrl + `/${lang}`  + env.translateSuffix, { headers: this.headers });
  }
}

export const ngxTranslateConfig: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useClass: WebpackTranslateLoader,
    deps: [HttpClient]
  }
};
